module.exports = __webpack_public_path__ + "static/movies-1f00e207d92384f73289b3fd3f9abff2.jpg";